// extracted by mini-css-extract-plugin
module.exports = {"card":"Cards_card__2HDT4"};